import server from "../Server";
import withErrorCheck from "../CheckError";

export interface LeaveGroupPayload {
  groupId: number;
  playerId: number;
}

export const LeaveGroup = async (payload: LeaveGroupPayload): Promise<boolean> => {
  console.log("LeaveGroup action called with:", payload);
  
  const deleteResponse = await server
    .from("GroupPlayers")
    .delete()
    .eq("group_id", payload.groupId)
    .eq("player_id", payload.playerId);

  console.log("LeaveGroup delete response:", deleteResponse);
  
  withErrorCheck(deleteResponse);
  
  return true;
};
